export default function gigProgress(
  state: string,
  networkName: string | null
): {text: string} {
  switch (state) {
    case 'rejected':
      return {text: 'Declined'};

    case 'expired':
      return {text: 'Expired'};

    case 'cancelled':
      return {text: 'Cancelled'};

    case 'proposed':
    case 'awaiting_preapproval':
      return {text: 'Application under review'};

    case 'awaiting_influencer_uploads':
      return {text: 'Submit your content'};

    case 'awaiting_influencer_posts':
      return {text: `Post to ${networkName || 'Network'}`};

    case 'awaiting_brand_uploads_feedback':
      return {text: 'Content is in review'};

    case 'awaiting_payment':
      return {text: 'Payment in progress'};

    case 'completed':
      return {text: 'Completed'};

    default:
      return {text: 'In Progress'};
  }
}
